import { Art57Node } from "./Node/Art57Node/Art57Node";
import { BaseNode } from "./Node/BaseNode";
import { ErrorType } from "./Node/ErrorType";

export class FieldsErrorsControl {
    private errors: any[] = [];
    private lastErrorVisited: any = null;
    private currentErrorIndex = -1;
    public validateButtonPressed = false;
    private lasterrorIDVisited: string = '';

    public getErrors(): any[] {
        return this.errors;
    }


    private findLastErrorVisited = (errorNodeToFind: any): number => {
        if (this.currentErrorIndex != -1) { // No nodes visited so don't search for the last visited node in the current errors array
            const index = this.errors.findIndex(element => {
                return (element.errorID === this.lasterrorIDVisited);
            });
            return index; // return -1 when errorToFind is not found in the current errors array
        }
        return -1; // there is no current index for current error (error fixed by user or not error visited) 
    };

    initializeErrors(errors: any[]) {
        // This methos is called copntinuosly by front-end onValidate method so whe should reset only when no errors found in method getTotalErrorsFound
        this.errors = errors.filter(e=>e.errorType!==ErrorType.errorInactive);

        if (this.lastErrorVisited) { // exist an error node from Previous validation
            // get the index for the last error in current array (if != -1 then lastErrorVisited was not fixed, else we have the new position in the array - if changed)
            this.currentErrorIndex = this.findLastErrorVisited(this.lastErrorVisited);
            this.lasterrorIDVisited = this.currentErrorIndex == -1 ? '' : this.errors[this.currentErrorIndex].errorID;
        } else {
            // if not found then -1
            this.currentErrorIndex = -1;
            this.lasterrorIDVisited = '';
        }

        this.getTotalErrorsFound(); // force the calculation of validateButtonPressed
    }

    updateErrors(errors: any[], node: Art57Node) {

        this.errors.filter(error => error.node.key === node.key).forEach(error => error.errorType = ErrorType.errorInactive);

        errors.forEach(error => {
            let errorIndexToUpdate = this.errors.findIndex(existingError => existingError.errorID === error.errorID);
            if (errorIndexToUpdate != -1) {
                this.errors[errorIndexToUpdate] = error;
            } else {
                // search last element for the same node where error is happening if located insert unfound error to the list in that position else insert error at the end of array
                const reverseIndex = [...this.errors].reverse().findIndex(existingError => existingError.node.key === error.node.key)
                if (reverseIndex != -1) {
                    this.errors.splice(this.errors.length - 1 - reverseIndex, 0, error);
                } else {
                    // insert error at the end of array in this case we don't loose the error when validating a single node without chidren validation
                    // this error inside the array will be ordered in case of validate button has been pressed again 
                    this.errors.push(error);
                }
            }
        });

        if ((this.getCurrentError()!=null) &&
            (this.getCurrentError().node.key !== node.key)) {
            this.currentErrorIndex = this.errors.findIndex(error=>error.node.key === node.key); // reposition to first error node in this node
        }

    }

    removeNodeErrors(node: BaseNode) {
        this.removeErrors(node);
    }

    private removeErrors(node: BaseNode) {
        node.children?.forEach(child => {
            this.removeErrors(child as BaseNode);
        });

        this.errors = this.errors.filter(error => error.node.key !== node.key);
    }

    private findErrorIndexAfter(startIndex: number): number {
        let index = -1;
        for (let i=startIndex;i<this.errors.length;i++) {
            if (this.errors[i].errorType !== ErrorType.errorInactive) {
                return i;
            }
        }
        return index;
    }

    private findErrorIndexPrevious(startIndex: number): number {
        let index = -1;
        for (let i=startIndex;i>-1;i--) {
            if (this.errors[i].errorType !== ErrorType.errorInactive) {
                return i;
            }
        }
        return index;
    }

    private setNextErrorIndex() {
        const nextErrorIndex = this.findErrorIndexAfter(this.currentErrorIndex+1);
        if (nextErrorIndex == -1) { // not found fixed error in errors tree, then reposition to first error 
            const currentErrors = this.errors.filter(error=>error.errorType !== ErrorType.errorInactive);
            this.currentErrorIndex = this.errors.indexOf(currentErrors[0]);
       } else { // Found next Error index
            this.currentErrorIndex = nextErrorIndex;
        }        
    }

    private setPreviousErrorIndex() {
        const previousErrorIndex = this.findErrorIndexPrevious(this.currentErrorIndex-1);
        if (previousErrorIndex == -1) { // not found fixed error in errors tree, then reposition to Last error 
            const currentErrors = this.errors.filter(error=>error.errorType !== ErrorType.errorInactive);
            this.currentErrorIndex = this.errors.indexOf(currentErrors[currentErrors.length-1]);            
        } else { // Found previous Error index
            this.currentErrorIndex = previousErrorIndex;
        }        
    }

    existsErrors(): boolean {
        return (this.errors) && (this.errors.filter(error=>error.errorType !== ErrorType.errorInactive).length>0);
    }

    getNextError(): any {
        if (!this.existsErrors()) {
            return null;
        }

        this.setNextErrorIndex();

        return this.getCurrentError();
    }

    getPreviousError(): any {
        if (!this.existsErrors()) {
            return null;
        }

        this.setPreviousErrorIndex();

        return this.getCurrentError();
    }

    getCurrentError(): any {
        if (!this.existsErrors()) {
            this.lasterrorIDVisited = '';
            return null;
        }

        this.currentErrorIndex = this.currentErrorIndex == -1?0:this.currentErrorIndex;
        this.lastErrorVisited = this.errors[this.currentErrorIndex];
        this.lasterrorIDVisited = this.lastErrorVisited.errorID;
        return this.lastErrorVisited;
    }

    getFirstError(): any {
        if (!this.existsErrors()) {
            this.lasterrorIDVisited = '';
            return null;
        }

        this.lasterrorIDVisited = this.errors[0].errorID;
        return this.errors[0];
    }

    setErrorsPositionToFistError() {
        this.currentErrorIndex = 0;
        this.getCurrentError();
    }

    private resetFieldsFormControl() {
        // set intial state for errors control
        this.validateButtonPressed = false;
        this.lastErrorVisited = null;
        this.lasterrorIDVisited = '';
        this.currentErrorIndex = -1;
    }


    getTotalErrorsFound(): number {

        if (!this.existsErrors()) {
            this.resetFieldsFormControl(); // reset control to initial state for next validationErrors
            return 0;
        }

        return this.errors.filter(e=>e.errorType!==ErrorType.errorInactive).length;
    }

    setValidateButtonPressed() {
        this.validateButtonPressed = true;
    }

    isValidateButtonPressed(): boolean {
        return this.validateButtonPressed;
    }
}